import styled from "styled-components";

export const GroupWrapper = styled.div`
  display: flex;
`;
